import { useHubSpot } from '../contexts/HubSpotProvider';

interface HubSpotFormOptions {
  portalId?: string;
  formId?: string;
  region?: string;
  title?: string;
  target?: string;
  defaultValues?: Record<string, string>;
}

export const useHubSpotForm = (defaultConfig?: HubSpotFormOptions) => {
  const { showForm, hideForm, isFormVisible } = useHubSpot();

  const openForm = (config?: HubSpotFormOptions) => {
    const finalConfig = {
      portalId: config?.portalId || defaultConfig?.portalId || "24047364",
      formId: config?.formId || defaultConfig?.formId || "4b422d55-a23b-49fc-823c-807855bd5a0c",
      region: config?.region || defaultConfig?.region || "na1",
      target: config?.target || defaultConfig?.target || "#hubspot-form-container",
      defaultValues: config?.defaultValues || defaultConfig?.defaultValues || {}
    };
    
    showForm(finalConfig);
  };

  return {
    openForm,
    closeForm: hideForm,
    isFormVisible
  };
};